import Clarity from '@microsoft/clarity';
import { useState } from "react";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Header from "../../common/header/Header";
import Form from "./form/Form";

export default function AdminWebinarAdd() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop] = useState(window.innerWidth > 768);
	const isAdmin = LoginHelper.isLoggedIn() && LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_ADMIN;
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'داشبورد مدیریت', href: '/dashboard/' },
		{ label: 'افزودن وبینار', href: '/admin_webinar_add/' },
	];

	if (!isAdmin) {
		return <Navigate to="/login/" replace />;
	}

	return (
		<>
			<Helmet>
				<title>افزودن وبینار مدیریت | همراهتیم</title>
				<meta name="description" content="افزودن وبینار توسط مدیریت همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen">
				<Header isDesktop={isDesktop} />
				<div className="bg-white">
					<div className={`${isDesktop ? 'w-[600px]' : ''} mx-auto`}>
						<Breadcrumb linkDataList={linkDataList} />
					</div>
				</div>
				<div className="max-w-[600px] mx-auto p-[10px]">
					<div className="spacer p-[50px]"></div>
					<Form />
				</div>
				<div className="spacer p-[50px]"></div>
			</div>
		</>
	)
}
